import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private toastrConfig = {
    timeOut: 8000,
    closeButton: true,
    enableHtml: true,
    toastClass: '',
    positionClass: ''
  };

  constructor(public toastr: ToastrService,
              private translate: TranslateService) {
  }

  showSuccessWithoutTranslation(message: string) {
    this.toastr.success(
      '<span class=" tim-icons icon-bell-55"></span>' + message,
      '',
      this.toastrConfig
    );
  }

  showSuccess(message?: string) {
    if (message == null || message == "") {
      message = "general.success";
    }
    this.showSuccessWithoutTranslation(this.translate.instant(message));
  }

  showError(message) {

    this.toastr.error('<span class=" tim-icons icon-alert-circle-exc"></span>' + this.translate.instant(message),
      this.translate.instant('general.error'),
      this.toastrConfig
    );
  }

  showWarning(message) {

    this.toastr.warning('<span class=" tim-icons icon-alert-circle-exc"></span>' + this.translate.instant(message),
      this.translate.instant('general.warning'),
      this.toastrConfig
    );
  }

  showErrorWithoutTranslate(message) {

    this.toastr.error(message,
      this.translate.instant('general.error'),
      this.toastrConfig
    );
  }

  showInfo(message) {

    this.toastr.info('<span class=" tim-icons icon-volume-98"></span>' + this.translate.instant(message),
      this.translate.instant('general.info'),
      this.toastrConfig
    );
  }

  showSocketNotification(title, message) {

    this.toastr.info('<span class=" tim-icons icon-volume-98"></span>' + message,
      this.translate.instant(title),
      this.toastrConfig
    );
  }

  showRequiredError(messageId) {
    this.showErrorWithoutTranslate(this.translate.instant(messageId) + " " + this.translate.instant('general.required') + "!",
    );
  }

  showErrorRawMessage(title, message) {

    this.toastr.error('<span class=" tim-icons icon-alert-circle-exc"></span>' + message, this.translate.instant(title), this.toastrConfig);
  }

}
